// kapigen version 0.1.34
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
import { HostSegmentWireFormat3 as KaggleSdkCompetitionsHostSegmentWireFormat3 } from "../competitions";
import { DataSourceWireFormat3 as KaggleSdkKernelsDataSourceWireFormat3 } from "../kernels";
import { ModelFrameworkWireFormat3 as KaggleSdkModelsModelFrameworkWireFormat3 } from "../models";
import { MedalWireFormat3 as KaggleSdkUsersMedalWireFormat3, OrganizationCardWireFormat3 as KaggleSdkUsersOrganizationCardWireFormat3, UserAchievementTierWireFormat3 as KaggleSdkUsersUserAchievementTierWireFormat3, UserAvatarWireFormat3 as KaggleSdkUsersUserAvatarWireFormat3 } from "../users";
var defaultCategoryFilter = {
    count: 0
};
export var CategoryFilterWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCategoryFilter, wireFormat);
        if (wireFormat) {
            message.name = DocumentTypeWireFormat3.fromJson(wireFormat.name);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
            message.count = parseInt(wireFormat.count);
        }
        return message;
    }
};
var defaultCommentItemInfo = {
    forumName: "",
    forumType: "",
    matchingText: "",
    topicUrl: "",
    totalReplies: 0
};
export var CommentItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCommentItemInfo, wireFormat);
        return message;
    }
};
var defaultCompetitionItemInfo = {
    teamsCount: 0,
    prizeValue: 0,
    hasEntered: false,
    isKernelsOnly: false,
    hostName: "",
    subtitle: ""
};
export var CompetitionItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionItemInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.deadlineDate) {
            message.deadlineDate = new Date(wireFormat.deadlineDate);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.prizeValue) != undefined) {
            message.prizeValue = Number(wireFormat.prizeValue);
        }
        if (wireFormat) {
            message.type = KaggleSdkCompetitionsHostSegmentWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultCourseItemInfo = {
    estimatedHours: 0,
    description: ""
};
export var CourseItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCourseItemInfo, wireFormat);
        return message;
    }
};
var defaultDatasetItemInfo = {
    size: 0,
    fileTypes: [],
    kernelsCount: 0,
    filesCount: 0,
    maintainedByKaggle: false,
    currentDatasetVersionId: 0,
    datasetSlug: "",
    totalDownloads: 0,
    subtitle: ""
};
export var DatasetItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetItemInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.size) {
            message.size = parseInt(wireFormat.size);
        }
        return message;
    }
};
var defaultFilterOption = {
    name: "",
    count: 0
};
export var FilterOptionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFilterOption, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
            message.count = parseInt(wireFormat.count);
        }
        return message;
    }
};
var defaultFullSearchResponse = {
    documents: [],
    count: 0,
    filters: [],
    categories: []
};
export var FullSearchResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFullSearchResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.documents) {
            message.documents = wireFormat.documents.map(function(i) {
                return SearchItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
            message.count = parseInt(wireFormat.count);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.filters) {
            message.filters = wireFormat.filters.map(function(i) {
                return SearchFilterWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = wireFormat.categories.map(function(i) {
                return CategoryFilterWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var FullSearchWebRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetAutoCompleteSuggestionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetAutoCompleteSuggestionsResponse = {
    autoCompleteSuggestions: []
};
export var GetAutoCompleteSuggestionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetAutoCompleteSuggestionsResponse, wireFormat);
        return message;
    }
};
export var GetPopularTagsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetPopularTagsResponse = {
    popularTags: []
};
export var GetPopularTagsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetPopularTagsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.popularTags) {
            message.popularTags = wireFormat.popularTags.map(function(i) {
                return FilterOptionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetRecentSearchesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.specificSearchIndices) {
            wireFormat.specificSearchIndices = message.specificSearchIndices.map(function(i) {
                return SearchIndexWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultGetRecentSearchesResponse = {
    recentSearches: []
};
export var GetRecentSearchesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetRecentSearchesResponse, wireFormat);
        return message;
    }
};
export var GetTrendingSearchesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetTrendingSearchesResponse = {
    trendingSearches: []
};
export var GetTrendingSearchesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetTrendingSearchesResponse, wireFormat);
        return message;
    }
};
var defaultIndexSnippetResponse = {
    indexCreateResponse: "",
    createdIndex: "",
    bulkIndexResponse: "",
    indexedCount: 0,
    deleteIndexResponse: "",
    deletedIndex: "",
    aliasResponse: ""
};
export var IndexSnippetResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultIndexSnippetResponse, wireFormat);
        return message;
    }
};
var defaultKernelItemInfo = {
    languageGroup: "",
    secondsToRun: 0,
    forksCount: 0,
    kernelSessionId: 0,
    hasDataOutputFiles: false,
    isUtilityScript: false,
    hasCollaborators: false,
    totalComments: 0,
    dataSources: []
};
export var KernelItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelItemInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
            message.dataSources = wireFormat.dataSources.map(function(i) {
                return KaggleSdkKernelsDataSourceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultListSearchContentDocument = {
    id: 0,
    title: "",
    url: "",
    imageUrl: "",
    slug: "",
    isCurrentUserBookmarked: false,
    collaborators: [],
    tags: []
};
export var ListSearchContentDocumentWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListSearchContentDocument, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.createTime) {
            message.createTime = new Date(wireFormat.createTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updateTime) {
            message.updateTime = new Date(wireFormat.updateTime);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.currentUserVote) != undefined) {
            message.currentUserVote = VoteWireFormat3.fromJson(wireFormat.currentUserVote);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.medal) != undefined) {
            message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.ownerUser) {
            message.ownerUser = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.ownerUser);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.ownerOrganization) {
            message.ownerOrganization = KaggleSdkUsersOrganizationCardWireFormat3.fromJson(wireFormat.ownerOrganization);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
            message.collaborators = wireFormat.collaborators.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListSearchContentFiltersWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.listType) {
            wireFormat.listType = ListTypeWireFormat3.toJson(message.listType);
        }
        if (message === null || message === void 0 ? void 0 : message.privacy) {
            wireFormat.privacy = PrivacyWireFormat3.toJson(message.privacy);
        }
        if (message === null || message === void 0 ? void 0 : message.ownerType) {
            wireFormat.ownerType = OwnerTypeWireFormat3.toJson(message.ownerType);
        }
        if (message === null || message === void 0 ? void 0 : message.documentTypes) {
            wireFormat.documentTypes = message.documentTypes.map(function(i) {
                return DocumentTypeWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var ListSearchContentRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.filters) {
            wireFormat.filters = ListSearchContentFiltersWireFormat3.toJson(message.filters);
        }
        if (message === null || message === void 0 ? void 0 : message.orderBy) {
            wireFormat.orderBy = ListSearchContentOrderByWireFormat3.toJson(message.orderBy);
        }
        return wireFormat;
    }
};
var defaultListSearchContentResponse = {
    documents: [],
    totalDocuments: 0,
    nextPageToken: ""
};
export var ListSearchContentResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListSearchContentResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.documents) {
            message.documents = wireFormat.documents.map(function(i) {
                return ListSearchContentDocumentWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var LogSearchRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if ((message === null || message === void 0 ? void 0 : message.secondsSpentSearching) != undefined && (message === null || message === void 0 ? void 0 : message.secondsSpentSearching) != 0) {
            wireFormat.secondsSpentSearching = Number.isFinite(message.secondsSpentSearching) ? message.secondsSpentSearching : Number(message.secondsSpentSearching).toString();
        }
        return wireFormat;
    }
};
var defaultModelItemInfo = {
    downloadCount: 0,
    notebookCount: 0,
    topicCount: 0,
    currentModelVersionId: 0,
    modelSlug: "",
    variationCount: 0,
    frameworks: [],
    subtitle: ""
};
export var ModelItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelItemInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.notebookCount) {
            message.notebookCount = parseInt(wireFormat.notebookCount);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.frameworks) {
            message.frameworks = wireFormat.frameworks.map(function(i) {
                return KaggleSdkModelsModelFrameworkWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultOrganizationItemInfo = {
    location: "",
    datasetCount: 0,
    competitionCount: 0,
    memberCount: 0
};
export var OrganizationItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultOrganizationItemInfo, wireFormat);
        return message;
    }
};
var defaultSearchFilter = {
    options: [],
    categories: []
};
export var SearchFilterWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchFilter, wireFormat);
        if (wireFormat) {
            message.name = FilterNameWireFormat3.fromJson(wireFormat.name);
        }
        if (wireFormat) {
            message.type = FilterTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.options) {
            message.options = wireFormat.options.map(function(i) {
                return FilterOptionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = wireFormat.categories.map(function(i) {
                return DocumentTypeWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultSearchItem = {
    id: "",
    databaseId: 0,
    title: "",
    url: "",
    thumbnailImageUrl: "",
    rank: 0,
    score: 0,
    isPrivate: false,
    votes: 0,
    authorSlug: "",
    authorDisplayName: "",
    matchedText: "",
    isCreatedByCurrentUser: false
};
export var SearchItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchItem, wireFormat);
        if (wireFormat) {
            message.documentType = DocumentTypeWireFormat3.fromJson(wireFormat.documentType);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.score) != undefined) {
            message.score = Number(wireFormat.score);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.commentInfo) {
            message.commentInfo = CommentItemInfoWireFormat3.fromJson(wireFormat.commentInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionInfo) {
            message.competitionInfo = CompetitionItemInfoWireFormat3.fromJson(wireFormat.competitionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetInfo) {
            message.datasetInfo = DatasetItemInfoWireFormat3.fromJson(wireFormat.datasetInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelInfo) {
            message.kernelInfo = KernelItemInfoWireFormat3.fromJson(wireFormat.kernelInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topicInfo) {
            message.topicInfo = TopicItemInfoWireFormat3.fromJson(wireFormat.topicInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userInfo) {
            message.userInfo = UserItemInfoWireFormat3.fromJson(wireFormat.userInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.organizationInfo) {
            message.organizationInfo = OrganizationItemInfoWireFormat3.fromJson(wireFormat.organizationInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelInfo) {
            message.modelInfo = ModelItemInfoWireFormat3.fromJson(wireFormat.modelInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.courseInfo) {
            message.courseInfo = CourseItemInfoWireFormat3.fromJson(wireFormat.courseInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tutorialInfo) {
            message.tutorialInfo = TutorialItemInfoWireFormat3.fromJson(wireFormat.tutorialInfo);
        }
        return message;
    }
};
var defaultSearchResultGroup = {
    documents: [],
    count: 0
};
export var SearchResultGroupWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchResultGroup, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.documents) {
            message.documents = wireFormat.documents.map(function(i) {
                return SearchItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.type = DocumentTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
            message.count = parseInt(wireFormat.count);
        }
        return message;
    }
};
var defaultSuggestedSearchResponse = {
    groups: []
};
export var SuggestedSearchResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSuggestedSearchResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.groups) {
            message.groups = wireFormat.groups.map(function(i) {
                return SearchResultGroupWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SuggestedSearchWebRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultTopicItemInfo = {
    forumName: "",
    forumType: "",
    matchingText: "",
    forumUrl: "",
    totalComments: 0
};
export var TopicItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTopicItemInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
            message.creationDate = new Date(wireFormat.creationDate);
        }
        return message;
    }
};
var defaultTutorialItemInfo = {
    trackName: "",
    trackUrl: "",
    exerciseDescription: ""
};
export var TutorialItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTutorialItemInfo, wireFormat);
        return message;
    }
};
var defaultUserItemInfo = {
    kernelsCount: 0,
    topicsCount: 0,
    description: "",
    location: "",
    job: ""
};
export var UserItemInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserItemInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastSeenDate) {
            message.lastSeenDate = new Date(wireFormat.lastSeenDate);
        }
        if (wireFormat) {
            message.performanceTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.performanceTier);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.registerDate) {
            message.registerDate = new Date(wireFormat.registerDate);
        }
        return message;
    }
};
export var DocumentType;
(function(DocumentType) {
    DocumentType["UNSPECIFIED"] = "unspecified";
    DocumentType["BLOG"] = "blog";
    DocumentType["COMPETITION"] = "competition";
    DocumentType["DATASET"] = "dataset";
    DocumentType["KERNEL"] = "kernel";
    DocumentType["COMMENT"] = "comment";
    DocumentType["TOPIC"] = "topic";
    DocumentType["USER"] = "user";
    DocumentType["COURSE"] = "course";
    DocumentType["TUTORIAL"] = "tutorial";
    DocumentType["MODEL"] = "model";
})(DocumentType || (DocumentType = {}));
export var DocumentTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DOCUMENT_TYPE_UNSPECIFIED":
            default:
                return DocumentType.UNSPECIFIED;
            case "BLOG":
                return DocumentType.BLOG;
            case "COMPETITION":
                return DocumentType.COMPETITION;
            case "DATASET":
                return DocumentType.DATASET;
            case "KERNEL":
                return DocumentType.KERNEL;
            case "COMMENT":
                return DocumentType.COMMENT;
            case "TOPIC":
                return DocumentType.TOPIC;
            case "USER":
                return DocumentType.USER;
            case "COURSE":
                return DocumentType.COURSE;
            case "TUTORIAL":
                return DocumentType.TUTORIAL;
            case "MODEL":
                return DocumentType.MODEL;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DocumentType.UNSPECIFIED:
            case 0:
            default:
                return "DOCUMENT_TYPE_UNSPECIFIED";
            case DocumentType.BLOG:
            case 1:
                return "BLOG";
            case DocumentType.COMPETITION:
            case 2:
                return "COMPETITION";
            case DocumentType.DATASET:
            case 3:
                return "DATASET";
            case DocumentType.KERNEL:
            case 5:
                return "KERNEL";
            case DocumentType.COMMENT:
            case 6:
                return "COMMENT";
            case DocumentType.TOPIC:
            case 8:
                return "TOPIC";
            case DocumentType.USER:
            case 9:
                return "USER";
            case DocumentType.COURSE:
            case 10:
                return "COURSE";
            case DocumentType.TUTORIAL:
            case 11:
                return "TUTORIAL";
            case DocumentType.MODEL:
            case 12:
                return "MODEL";
        }
    }
};
export var FilterName;
(function(FilterName) {
    FilterName["DATE"] = "date";
    FilterName["IN"] = "in";
    FilterName["BY"] = "by";
    FilterName["TAGS"] = "tags";
    FilterName["OWNER"] = "owner";
    FilterName["SORT_BY"] = "sortBy";
    FilterName["COMPETITION_EVALUATION_ALGORITHM"] = "competitionEvaluationAlgorithm";
    FilterName["DATASET_LICENSE"] = "datasetLicense";
    FilterName["DATASET_SIZE"] = "datasetSize";
    FilterName["DATASET_SIZE_GROUP"] = "datasetSizeGroup";
    FilterName["DATASET_FILE_TYPES"] = "datasetFileTypes";
    FilterName["NOTEBOOK_LANGUAGE"] = "notebookLanguage";
    FilterName["VIEWED_BY_YOU"] = "viewedByYou";
    FilterName["CREATOR"] = "creator";
    FilterName["MODEL_LICENSE"] = "modelLicense";
    FilterName["MODEL_FRAMEWORK"] = "modelFramework";
})(FilterName || (FilterName = {}));
export var FilterNameWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATE":
            default:
                return FilterName.DATE;
            case "IN":
                return FilterName.IN;
            case "BY":
                return FilterName.BY;
            case "TAGS":
                return FilterName.TAGS;
            case "OWNER":
                return FilterName.OWNER;
            case "SORT_BY":
                return FilterName.SORT_BY;
            case "COMPETITION_EVALUATION_ALGORITHM":
                return FilterName.COMPETITION_EVALUATION_ALGORITHM;
            case "DATASET_LICENSE":
                return FilterName.DATASET_LICENSE;
            case "DATASET_SIZE":
                return FilterName.DATASET_SIZE;
            case "DATASET_SIZE_GROUP":
                return FilterName.DATASET_SIZE_GROUP;
            case "DATASET_FILE_TYPES":
                return FilterName.DATASET_FILE_TYPES;
            case "NOTEBOOK_LANGUAGE":
                return FilterName.NOTEBOOK_LANGUAGE;
            case "VIEWED_BY_YOU":
                return FilterName.VIEWED_BY_YOU;
            case "CREATOR":
                return FilterName.CREATOR;
            case "MODEL_LICENSE":
                return FilterName.MODEL_LICENSE;
            case "MODEL_FRAMEWORK":
                return FilterName.MODEL_FRAMEWORK;
        }
    }
};
export var FilterType;
(function(FilterType) {
    FilterType["RADIO"] = "radio";
    FilterType["CHECKBOX"] = "checkbox";
    FilterType["TEXT"] = "text";
})(FilterType || (FilterType = {}));
export var FilterTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "RADIO":
            default:
                return FilterType.RADIO;
            case "CHECKBOX":
                return FilterType.CHECKBOX;
            case "TEXT":
                return FilterType.TEXT;
        }
    }
};
export var ListSearchContentOrderBy;
(function(ListSearchContentOrderBy) {
    ListSearchContentOrderBy["LIST_CONTENT_ORDER_BY_UNSPECIFIED"] = "listContentOrderByUnspecified";
    ListSearchContentOrderBy["LIST_CONTENT_ORDER_BY_DATE_CREATED"] = "listContentOrderByDateCreated";
    ListSearchContentOrderBy["LIST_CONTENT_ORDER_BY_DATE_UPDATED"] = "listContentOrderByDateUpdated";
    ListSearchContentOrderBy["LIST_CONTENT_ORDER_BY_HOTNESS"] = "listContentOrderByHotness";
    ListSearchContentOrderBy["LIST_CONTENT_ORDER_BY_LAST_VIEWED"] = "listContentOrderByLastViewed";
    ListSearchContentOrderBy["LIST_CONTENT_ORDER_BY_TOTAL_COMMENTS"] = "listContentOrderByTotalComments";
    ListSearchContentOrderBy["LIST_CONTENT_ORDER_BY_VOTES"] = "listContentOrderByVotes";
})(ListSearchContentOrderBy || (ListSearchContentOrderBy = {}));
export var ListSearchContentOrderByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ListSearchContentOrderBy.LIST_CONTENT_ORDER_BY_UNSPECIFIED:
            case 0:
            default:
                return "LIST_CONTENT_ORDER_BY_UNSPECIFIED";
            case ListSearchContentOrderBy.LIST_CONTENT_ORDER_BY_DATE_CREATED:
            case 1:
                return "LIST_CONTENT_ORDER_BY_DATE_CREATED";
            case ListSearchContentOrderBy.LIST_CONTENT_ORDER_BY_DATE_UPDATED:
            case 2:
                return "LIST_CONTENT_ORDER_BY_DATE_UPDATED";
            case ListSearchContentOrderBy.LIST_CONTENT_ORDER_BY_HOTNESS:
            case 3:
                return "LIST_CONTENT_ORDER_BY_HOTNESS";
            case ListSearchContentOrderBy.LIST_CONTENT_ORDER_BY_LAST_VIEWED:
            case 4:
                return "LIST_CONTENT_ORDER_BY_LAST_VIEWED";
            case ListSearchContentOrderBy.LIST_CONTENT_ORDER_BY_TOTAL_COMMENTS:
            case 5:
                return "LIST_CONTENT_ORDER_BY_TOTAL_COMMENTS";
            case ListSearchContentOrderBy.LIST_CONTENT_ORDER_BY_VOTES:
            case 6:
                return "LIST_CONTENT_ORDER_BY_VOTES";
        }
    }
};
export var ListType;
(function(ListType) {
    ListType["UNSPECIFIED"] = "unspecified";
    ListType["LANDING_CARDS"] = "landingCards";
    ListType["LANDING_LIST"] = "landingList";
    ListType["USER_PROFILE"] = "userProfile";
    ListType["YOUR_WORK"] = "yourWork";
    ListType["PROJECTS"] = "projects";
    ListType["BOOKMARKS"] = "bookmarks";
})(ListType || (ListType = {}));
export var ListTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ListType.UNSPECIFIED:
            case 0:
            default:
                return "LIST_TYPE_UNSPECIFIED";
            case ListType.LANDING_CARDS:
            case 1:
                return "LIST_TYPE_LANDING_CARDS";
            case ListType.LANDING_LIST:
            case 2:
                return "LIST_TYPE_LANDING_LIST";
            case ListType.USER_PROFILE:
            case 3:
                return "LIST_TYPE_USER_PROFILE";
            case ListType.YOUR_WORK:
            case 4:
                return "LIST_TYPE_YOUR_WORK";
            case ListType.PROJECTS:
            case 5:
                return "LIST_TYPE_PROJECTS";
            case ListType.BOOKMARKS:
            case 6:
                return "LIST_TYPE_BOOKMARKS";
        }
    }
};
export var OwnerType;
(function(OwnerType) {
    OwnerType["OWNER_ANY"] = "ownerAny";
    OwnerType["OWNER_COLLABORATIONS"] = "ownerCollaborations";
    OwnerType["OWNER_SHARED_WITH_CURRENT_USER"] = "ownerSharedWithCurrentUser";
})(OwnerType || (OwnerType = {}));
export var OwnerTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case OwnerType.OWNER_ANY:
            case 0:
            default:
                return "OWNER_ANY";
            case OwnerType.OWNER_COLLABORATIONS:
            case 1:
                return "OWNER_COLLABORATIONS";
            case OwnerType.OWNER_SHARED_WITH_CURRENT_USER:
            case 2:
                return "OWNER_SHARED_WITH_CURRENT_USER";
        }
    }
};
export var Privacy;
(function(Privacy) {
    Privacy["ANY"] = "any";
    Privacy["PRIVATE"] = "private";
    Privacy["PUBLIC"] = "public";
})(Privacy || (Privacy = {}));
export var PrivacyWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case Privacy.ANY:
            case 0:
            default:
                return "PRIVACY_ANY";
            case Privacy.PRIVATE:
            case 1:
                return "PRIVACY_PRIVATE";
            case Privacy.PUBLIC:
            case 2:
                return "PRIVACY_PUBLIC";
        }
    }
};
export var SearchIndex;
(function(SearchIndex) {
    SearchIndex["UNSPECIFIED"] = "unspecified";
    SearchIndex["COMPETITIONS"] = "competitions";
    SearchIndex["DATASETS"] = "datasets";
    SearchIndex["GLOBAL"] = "global";
    SearchIndex["KERNELS"] = "kernels";
    SearchIndex["TOPICS"] = "topics";
    SearchIndex["MODELS"] = "models";
})(SearchIndex || (SearchIndex = {}));
export var SearchIndexWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case SearchIndex.UNSPECIFIED:
            case 0:
            default:
                return "SEARCH_INDEX_UNSPECIFIED";
            case SearchIndex.COMPETITIONS:
            case 1:
                return "COMPETITIONS";
            case SearchIndex.DATASETS:
            case 2:
                return "DATASETS";
            case SearchIndex.GLOBAL:
            case 3:
                return "GLOBAL";
            case SearchIndex.KERNELS:
            case 5:
                return "KERNELS";
            case SearchIndex.TOPICS:
            case 6:
                return "TOPICS";
            case SearchIndex.MODELS:
            case 7:
                return "MODELS";
        }
    }
};
export var Vote;
(function(Vote) {
    Vote["UNSPECIFIED"] = "unspecified";
    Vote["UP"] = "up";
    Vote["DOWN"] = "down";
})(Vote || (Vote = {}));
export var VoteWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "VOTE_UNSPECIFIED":
            default:
                return Vote.UNSPECIFIED;
            case "VOTE_UP":
                return Vote.UP;
            case "VOTE_DOWN":
                return Vote.DOWN;
        }
    }
};
// Search is structured such that some handlers live on a service-host container
// and a proxied by web pods, while some handlers live on the actual web
// monolith. Because a ProtoServiceRegistration requires all RPCs to have mapped
// handlers, it's thus necessary to divide these two services so that web pods
// can have their own RPCs while not defining handlers for the proxied requests.
export var searchClient = {
    searchContentService: {
        // Returns a list of search-backed content using the provide filters/sort
        listSearchContent: createClient(ListSearchContentRequestWireFormat3, ListSearchContentResponseWireFormat3, "search.SearchContentService/ListSearchContent")
    },
    searchWebService: {
        fullSearchWeb: createClient(FullSearchWebRequestWireFormat3, FullSearchResponseWireFormat3, "search.SearchWebService/FullSearchWeb"),
        getAutoCompleteSuggestions: createClient(GetAutoCompleteSuggestionsRequestWireFormat3, GetAutoCompleteSuggestionsResponseWireFormat3, "search.SearchWebService/GetAutoCompleteSuggestions"),
        getPopularTags: createClient(GetPopularTagsRequestWireFormat3, GetPopularTagsResponseWireFormat3, "search.SearchWebService/GetPopularTags"),
        getRecentSearches: createClient(GetRecentSearchesRequestWireFormat3, GetRecentSearchesResponseWireFormat3, "search.SearchWebService/GetRecentSearches"),
        getTrendingSearches: createClient(GetTrendingSearchesRequestWireFormat3, GetTrendingSearchesResponseWireFormat3, "search.SearchWebService/GetTrendingSearches"),
        logSearch: createClient(LogSearchRequestWireFormat3, google.protobuf.EmptyWireFormat3, "search.SearchWebService/LogSearch"),
        suggestedSearchWeb: createClient(SuggestedSearchWebRequestWireFormat3, SuggestedSearchResponseWireFormat3, "search.SearchWebService/SuggestedSearchWeb")
    }
};
